import { companyApis } from '@apis/companyApis';
import { useMutation } from '@hooks/useMutation';
import type { PatchCompany } from '@models/Company';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchCompany = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PatchCompany) => {
      const response = await companyApis.patch('/company/', { body });
      if (response[400]) {
        throw new FormError('PatchCompany', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/company/']);
      },
    },
  );
};
